import React, { Fragment } from 'react';

import { SignupForm, MetaData } from '../components';

class Signup extends React.Component {
    render() {
        return (
            <Fragment>

                <MetaData page={'signup'} />
                <SignupForm />

            </Fragment>
        )

    }
}

export default Signup;


// WEBPACK FOOTER //
// ./src/js/views/Signup.js